import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './App.css';
import InternetDisable from './InternetDisabled';
// import { BrowserRouter } from 'react-router-dom';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    {/* <BrowserRouter basename={process.env.PUBLIC_URL}> */}
    {navigator.onLine ? <App /> : <InternetDisable />}
    {/* </BrowserRouter> */}
  </React.StrictMode>
);
